import { logValidationErrors } from './logValidationErrors';
import { validateMessageAndThrow } from './validateMessageAndThrow';
const createSocketMessageEventListener = ({ endpointName = 'unknownEndpoint', validationSchema, validationSchemaPath, queryArgument, messageMutation, listener }) => (message, eventName) => {
    messageMutation?.(message);
    try {
        validateMessageAndThrow(validationSchema, message, validationSchemaPath);
    }
    catch (ex) {
        logValidationErrors(`${endpointName}() -> '${eventName}' message handler, `, ex);
        return;
    }
    if (queryArgument)
        listener({ message, endpointName, eventName, validQueryArgument: queryArgument });
    else
        listener({ message, endpointName, eventName });
};
export { createSocketMessageEventListener };
